// extracted by mini-css-extract-plugin
export default {"eachdiv":"BookList_eachdiv__kjuHk","subdiv":"BookList_subdiv__pUqJc"};